<template>
  <div>
      <CaptureComponent/>
  </div>
</template>

<script>
import CaptureComponent from '@/components/CaptureComponent.vue';
export default {
  name: 'capture',
  components: {
    CaptureComponent
  }
}
</script>
